<template>
  <div>
    <a-modal v-model="visible"
             title="关于系统升级维护的通知"
             :closable="false"
             :maskClosable="false"
             :footer="null"
             :keyboard="false">
      <p style="font-size: 24px;color: #0c1b2e;">尊敬的用户：</p>
      <p style="font-size: 18px;color: #0c1b2e;">系统维护升级中，暂时无法访问。抱歉给您带来的不便。</p>
      <p style="font-size: 14px;color: #0c1b2e;text-align: right;">杭州诚捷环保设备有限公司</p>
      <p style="font-size: 14px;color: #0c1b2e;text-align: right;">2022年10月15日</p>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: "maintain",
  data(){
    return{
      visible: true
    }
  }
}
</script>

<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/views/maintain/maintain.vue